/**
 * Formater une date Firestore en "il y a X temps"
 */
export function formatTimeAgo(timestamp) {
  if (!timestamp) return "À l'instant";

  try {
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);

    if (seconds < 60) return "À l'instant";

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `il y a ${minutes} min`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `il y a ${hours}h`;

    const days = Math.floor(hours / 24);
    if (days < 7) return `il y a ${days}j`;

    const weeks = Math.floor(days / 7);
    if (weeks < 4) return `il y a ${weeks} sem`;

    const months = Math.floor(days / 30);
    if (months < 12) return `il y a ${months} mois`;

    const years = Math.floor(days / 365);
    return `il y a ${years} an${years > 1 ? 's' : ''}`;
  } catch {
    return "À l'instant";
  }
}
